<template>
    <div class="luck-draw-index">
        <lucky-draw/>
    </div>
</template>

<script>
    import LuckyDraw from '../../components/luck-draw-activity/luckywheel'

    export default {
        name: "MyLuckyDraw",
        components: {
            LuckyDraw
        }

    }
</script>

<style scoped>


</style>


// WEBPACK FOOTER //
// MyLuckDraw.vue?722e9ba2